
import { Vue, Component, Prop } from "vue-property-decorator";

interface HealthInformationData {
  medical_conditions: string[];
  past_conditions: string[];
  client_medications: {
    client_id: string;
    dosage: string;
    file: boolean;
    frequency: string;
    name: string;
    id: string;
  }[];
  allergies_food: string[];
  allergies_medication: string[];
  allergies_environmental: string[];
  dnr_order: string;
}

@Component
export default class HealthInformation extends Vue {
  @Prop({ required: true }) readonly data!: HealthInformationData;
}
